import { memo } from 'react';

import MicrosoftOneDriveIcon from '@/assets/microsoft-one-drive-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type MicrosoftOneDriveLogoProps = LogoProps;

const IMicrosoftOneDriveLogo = ({ className, ...rest }: MicrosoftOneDriveLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <MicrosoftOneDriveIcon className="size-5" />
    </Logo>
  );
};

export const MicrosoftOneDriveLogo = memo(IMicrosoftOneDriveLogo) as typeof IMicrosoftOneDriveLogo;
